import { SegmentedControl, SegmentedControlProps, Text } from "@mantine/core";

interface Props extends SegmentedControlProps {
  label?: string;
}
export const UserPermWithOwnerSegmentedControl = (props: Partial<Props>) => {
  return (
    <div>
      {props.label && (
        <Text size="sm" fw={500} mb={3}>
          {props.label}
        </Text>
      )}
      <SegmentedControl
        {...props}
        data={[
          { label: "Owner", value: "o" },
          { label: "Manager", value: "m" },
          { label: "Viewer", value: "v" },
        ]}
      />
    </div>
  );
};

export const UserPermWithoutOwnerSegmentedControl = (props: Partial<Props>) => {
  return (
    <div>
      {props.label && (
        <Text size="sm" fw={500} mb={3}>
          {props.label}
        </Text>
      )}
      <SegmentedControl
        {...props}
        data={[
          { label: "Manager", value: "m" },
          { label: "Viewer", value: "v" },
        ]}
      />
    </div>
  );
};
